const clearButton = document.createElement('div');
var wrapper;
var input;
clearButton.className = 'input-clear-btn';

function inputChanged() {
    if (input.value == "")
        wrapper.classList.remove('show-clear-btn');
    else
        wrapper.classList.add('show-clear-btn');
}

function clear(e) {
    input.value = "";
    inputChanged();
    input.focus();
}

function init() {
    wrapper = document.querySelector('.search-form .search--input');
    if (wrapper) {

        input = wrapper.querySelector('input[type=search]');
        input.addEventListener('change', inputChanged);
        input.addEventListener('keyup', inputChanged);
        wrapper.appendChild(clearButton);
        clearButton.addEventListener('click', clear);

        inputChanged();
    }
}

export default function searchInputHelper() {
    document.addEventListener('DOMContentLoaded', init);
}